import React, { Suspense, useContext, useEffect, useRef, useState } from "react";
import FormCreator from "../../components/forms/FormCreator";
import { useLazyGetAccountInformationByIdQuery, useLazyGetAllDropDownsForTaskListQuery, useRejectMemberApplicationMutation, useSaveIndividualMemberClarificationDetailsMutation, useSendPaymentLinkForIndividualMembershipMutation, useUpdateApplicationTypeFromTaskListMutation } from "../../app/services/MembershipTaskList/MembershipTaskListServiceApi";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import SwalAlert from "../../services/swalService/SwalService";
import CKEditorComponent from "../../components/forms/ui/inputs/ckEditor/CKEditor";
import { EditMembershipTaskListFormData } from "./data/EditMembershipTaskListForm.Data";
import MembershipTaskListContext from "./MembershipTaskListContextProvider";
import { editTaskListDropDowns, setEditTaskListFormInitials } from "./utils/EditTaskListSetFormFields";
import { getAuditContext } from "../../lib/authenticationLibrary";

const EditMembershipTaskListForm = () => {
    const params = useParams();
    const navigate = useNavigate();
    const membershipTaskListFormRef = useRef();
    const { confirm, success, error } = SwalAlert();
    const audit = getAuditContext();
    const [rejectComments, setRejectComments] = useState("");
    const [isModalOpenReject, setIsModalOpenReject] = useState(false);
    const [clarificationsComments, setClarificationsComments] = useState("");
    const [isModalOpenClarification, setIsModalOpenClarification] = useState(false);
    const { taskListDetailsData, fetchTaskListDetails } = useContext(MembershipTaskListContext);
    const [membershipTaskListForm, setmembershipTaskListForm] = useState(EditMembershipTaskListFormData);
    const allowSendPaymentLink = taskListDetailsData?.applicationTypeId === 4 ? taskListDetailsData?.isAdmissionBoardSubmittedByAdmin : taskListDetailsData?.isAdmissionBoardSubmittedByAdmin && taskListDetailsData?.isBoardCommitteeSubmittedByAdmin;

    const [getAccountInformationById, {
        isLoading: getAccountInformationByIdIsLoading,
        data: getAccountInformationByIdData,
        isSuccess: getAccountInformationByIdSuccess
    }] = useLazyGetAccountInformationByIdQuery();

    const [getTaskListDropDown, {
        isLoading: taskListDropDownIsLoading,
        data: taskListDropDownData,
        isSuccess: taskListDropDownIsSuccess }] = useLazyGetAllDropDownsForTaskListQuery();

    const [sendPaymentLinkForIndividualMembership, {
        isLoading: sendPaymentLinkForIndividualMembershipIsLoading,
        data: sendPaymentLinkForIndividualMembershipData,
        isSuccess: sendPaymentLinkForIndividualMembershipIsSuccess }] = useSendPaymentLinkForIndividualMembershipMutation();

    const [rejectMemberApplication, {
        isLoading: rejectMemberApplicationIsLoading,
        data: rejectMemberApplicationData,
        isSuccess: rejectMemberApplicationIsSuccess }] = useRejectMemberApplicationMutation();

    const [saveIndividualMemberClarificationDetails, {
        isLoading: saveIndividualMemberClarificationDetailsIsLoading,
        data: saveIndividualMemberClarificationDetailsData,
        isSuccess: saveIndividualMemberClarificationDetailsIsSuccess }] = useSaveIndividualMemberClarificationDetailsMutation();

    const [updateApplicationTypeFromTaskList, {
        isLoading: updateApplicationTypeIsLoading,
        data: updateApplicationTypeResponse,
        isSuccess: updateApplicationTypeIsSuccess }] = useUpdateApplicationTypeFromTaskListMutation();

    useEffect(() => {
        if (!updateApplicationTypeIsLoading && updateApplicationTypeIsSuccess && updateApplicationTypeResponse) {
            success("Application type updated.", "Success").then(() => { handleBack() });
        }
    }, [updateApplicationTypeIsLoading, updateApplicationTypeIsSuccess, updateApplicationTypeResponse]);

    useEffect(() => {
        if (!taskListDropDownIsLoading && taskListDropDownIsSuccess && taskListDropDownData) {
            setAllDropDownFieldsBatch(EditMembershipTaskListFormData, editTaskListDropDowns, taskListDropDownData);
        }
    }, [taskListDropDownIsLoading, taskListDropDownIsSuccess, taskListDropDownData]);

    useEffect(() => {
        if (!saveIndividualMemberClarificationDetailsIsLoading && saveIndividualMemberClarificationDetailsIsSuccess && saveIndividualMemberClarificationDetailsData) {
            success("Clarification send successfully", "Success").then(() => { openModalClarification(); handleBack() });
        }
    }, [saveIndividualMemberClarificationDetailsIsLoading, saveIndividualMemberClarificationDetailsIsSuccess, saveIndividualMemberClarificationDetailsData]);

    useEffect(() => {
        if (!rejectMemberApplicationIsLoading && rejectMemberApplicationIsSuccess && rejectMemberApplicationData) {
            success("Reject application successfully", "Success").then(() => { openModalReject(); handleBack() });
        }
    }, [rejectMemberApplicationIsLoading, rejectMemberApplicationIsSuccess, rejectMemberApplicationData]);

    useEffect(() => {
        if (!sendPaymentLinkForIndividualMembershipIsLoading && sendPaymentLinkForIndividualMembershipIsSuccess && sendPaymentLinkForIndividualMembershipData) {
            success("Payment link send successfully", "Success").then(() => { handleBack() });
        }
    }, [sendPaymentLinkForIndividualMembershipIsLoading, sendPaymentLinkForIndividualMembershipIsSuccess, sendPaymentLinkForIndividualMembershipData]);

    useEffect(() => {
        if (!getAccountInformationByIdIsLoading && getAccountInformationByIdData && getAccountInformationByIdSuccess) {
            const updatedTaskListForm = setEditTaskListFormInitials(getAccountInformationByIdData, membershipTaskListForm);

            let updatedSections = [...updatedTaskListForm.section];
            if (getAccountInformationByIdData.membershipType === 4) {
            updatedSections = updatedSections.filter(section => section?.wrapperTemplate?.props?.title !== "Board of Directors Approval" );
        }
            setmembershipTaskListForm({ ...updatedTaskListForm ,
                 section: updatedSections
            });
        }
    }, [getAccountInformationByIdIsLoading, getAccountInformationByIdData, getAccountInformationByIdSuccess]);

    useEffect(() => {
        if (params) {
            const ipasMemberId = Number(decryptAESID(params.memberId));
            const taskListId = Number(decryptAESID(params.taskListId));
            if (!ipasMemberId || !taskListId) {
                return;
            }
            let request = {
                ipasMemberId: ipasMemberId,
                taskListId: taskListId,
            }
            getAccountInformationById(request);
            fetchTaskListDetails(request);
        }
    }, [params]);

    useEffect(() => {
        getTaskListDropDown();
    }, [])

    const handleReject = () => {
        if (rejectComments === "" || rejectComments === undefined || rejectComments === null) {
            return error("The comments field for rejecting the application is mandatory and must be filled out.", "error")
        }
        let request = {
            ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
            SendRejectionReason: rejectComments,
            UpdatedBy : audit.adminUserId,
            UpdatedAppId : audit.appId
        }
        confirm("Reject Application?", "Are you sure you want to Reject?", "Yes", "No")
            .then((confirmed) => {
                if (confirmed) {
                    rejectMemberApplication(request);
                }
            });
    }

    const handleSendClearfication = () => {
        if (clarificationsComments === "" || clarificationsComments === undefined || clarificationsComments === null) {
            return error("The comments field for rejecting the application is mandatory and must be filled out.", "error")
        }
        let request = {
            IPASMemberId: Number(decryptAESID(params.memberId)),
            ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
            ClarificationDetails: clarificationsComments,
            UpdatedBy : audit.adminUserId,
            UpdatedAppId : audit.appId
        }
        confirm("Send Clarification?", "Are you sure you want to send clarification?", "Yes", "No")
            .then((confirmed) => {
                if (confirmed) {
                    saveIndividualMemberClarificationDetails(request);
                }
            });
    }

    const sendPaymentLink = () => {
        const editTaskListFormData = membershipTaskListFormRef?.current?.getFormData();
        if (!editTaskListFormData) {
            error("Please enter Subscription start date", "Error");
            return;
        }
        else if (getAccountInformationByIdData?.isRenewAllow === true) {
            error(
                "A renewal process is currently in progress. Please complete the renewal before proceeding with the upgrade.",
                "Oops!"
            ); return;
        }
        else {
            let request = {
                IPASMemberId: Number(decryptAESID(params.memberId)),
                ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
                SubscriptionStartDate: editTaskListFormData.selectedSubscriptionStartDate,
                ApplicationTypeId: editTaskListFormData.membershipType,
                UpdatedBy: audit.adminUserId,
                UpdatedAppId: audit.appId
            }
            sendPaymentLinkForIndividualMembership(request);
        }
    }

    const handleCKOnChange = (text, section) => {
        switch (section) {
            case "Clarification":
                setClarificationsComments(text);
                break;
            case "Reject":
                setRejectComments(text);
                break;
            default:
                break;
        }
    };

    const openModalReject = () => {
        setIsModalOpenReject(!isModalOpenReject);
    }
    const openModalClarification = () => {
        setIsModalOpenClarification(!isModalOpenClarification);
    }
    const handleBack = () => {
        navigate(-1);
    }
    const handleActionChange = (action, formData) => {
        if (action === 'VIEW_INDIVIDUAL_INFORMATION') {
            window.open(`/EditViewIndividualMember/${params.memberId}`, "_blank")

        }
    }
    const handleFieldChange = (fieldName, formData) => {
        if (fieldName === 'membershipType' && formData[fieldName]) {
            const { label, value } = formData.membershipType;
            let originalMembershipType = getAccountInformationByIdData.membershipType;
            if (value === originalMembershipType) return;
            if (originalMembershipType < value) {
                error("Can not change memberhsip type to higher tier.", "Validation Error");
                setmembershipTaskListForm({ ...membershipTaskListForm, initialState: { ...membershipTaskListForm.initialState, ...formData, membershipType: originalMembershipType } });
                return;
            }
            confirm("Confirm!", "Your action will be saved, it is not revertable", "Save", "Cancel").then((res) => {
                if (res) {
                    const request = {
                        IPASMemberId: Number(decryptAESID(params.memberId)),
                        ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
                        NewMembershipType: value,
                        CreatedBy: audit.adminUserId,
                        CreatedAppId: audit.appId
                    }
                    updateApplicationTypeFromTaskList(request);
                }
                else {
                    setmembershipTaskListForm({ ...membershipTaskListForm, initialState: { ...membershipTaskListForm.initialState, ...formData, membershipType: originalMembershipType } });
                }
            })
        }
    }

    return (
        <div>
            <div className="membership-application">
                {membershipTaskListForm && <Suspense fallback={<DataLoader />}>
                    <div className="vertical-form">
                        <FormCreator
                            config={membershipTaskListForm}
                            ref={membershipTaskListFormRef}
                            key={false}
                            onActionChange={handleActionChange}
                            onColumnChange={handleFieldChange}
                        />
                        <div className="d-flex justify-content-between form-card custom-btn-sec">
                            <Buttons
                                onClick={openModalReject}
                                buttonText={"Reject Application"}
                                buttonTypeClassName="theme-btn btn"
                                isLoading={rejectMemberApplicationIsLoading}
                            />
                            <Buttons
                                onClick={openModalClarification}
                                buttonText={"Send Clarifications"}
                                buttonTypeClassName="yellow-btn btn"
                                isLoading={saveIndividualMemberClarificationDetailsIsLoading}
                            />
                            <Buttons
                                onClick={sendPaymentLink}
                                buttonText={"Send Payment Link"}
                                buttonTypeClassName="theme-btn btn"
                                isLoading={sendPaymentLinkForIndividualMembershipIsLoading}
                                isDisable={!allowSendPaymentLink}
                            />
                        </div>
                    </div>
                </Suspense>
                }
                <div>
                    <Buttons
                        onClick={handleBack}
                        buttonText={"Back"}
                        buttonTypeClassName="back-btn mt-4 btn"
                        isLoading={false}
                    />
                </div>
            </div>
            {isModalOpenClarification && <CenterModel
                modelTitle={'Send Clarification'}
                show={"test"}
                handleClose={openModalClarification}
                onUpload={openModalClarification}
            >
                <CKEditorComponent onCKEditorChange={(e) => handleCKOnChange(e, "Clarification")} />
                <Buttons
                    buttonText=" Send Clarification "
                    buttonTypeClassName="theme-btn btn mt-5"
                    isLoading={saveIndividualMemberClarificationDetailsIsLoading}
                    onClick={handleSendClearfication}
                />
            </CenterModel>
            }
            {isModalOpenReject && <CenterModel
                modelTitle={'Reject Application'}
                show={"test"}
                handleClose={openModalReject}
                onUpload={openModalReject}
            >
                <CKEditorComponent onCKEditorChange={(e) => handleCKOnChange(e, "Reject")} />
                <Buttons
                    buttonText="Reject Application"
                    buttonTypeClassName="theme-btn btn mt-5"
                    isLoading={rejectMemberApplicationIsLoading}
                    onClick={handleReject}
                />
            </CenterModel>
            }
        </div>
    );
};
export default EditMembershipTaskListForm;
